'use strict';

var React = require('react');

var SvgQuestionMarkInverseMinor = function SvgQuestionMarkInverseMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 12h-2v-.148c0-.876.306-1.499 1-1.852.385-.195 1-.568 1-1a1.001 1.001 0 0 0-2 0h-2c0-1.654 1.346-3 3-3s3 1 3 3-2 2.165-2 3zm-2 3h2v-2h-2v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0z"
  }));
};

exports.SvgQuestionMarkInverseMinor = SvgQuestionMarkInverseMinor;
